/**
 * Created by abbeymart on 2017-02-18.
 */

import type { RouteRecordRaw } from 'vue-router';

export const locationRoutes: Array<RouteRecordRaw> = [
  {
    path: '/location',
    name: 'location',
    redirect: '/location/list',
    component: () => import('pages/central/location/McLocation.vue'),
    meta: {
      title: 'Locations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'locationList',
        component: () => import('pages/central/location/LocationList.vue'),
        meta: {
          title: 'Locations List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'locationDetail',
        component: () => import('pages/central/location/LocationDetail.vue'),
        meta: {
          title: 'Location Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'locationNew',
        component: () => import('pages/central/location/LocationNew.vue'),
        meta: {
          title: 'New Location',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'locationExplorer',
        component: () => import('pages/central/location/LocationExplorerDtable.vue'),
        meta: {
          title: 'Locations Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
